import ForumLegalPublicPage from "./ForumLegalPublicPage";

const TermsAndConditionsPage = () => (
  <ForumLegalPublicPage
    settingKey="terms_and_conditions"
    fallbackTitle="Terms and Conditions"
    errorMessage="Unable to load Terms and Conditions."
  />
);

export default TermsAndConditionsPage;
